var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90692 13.4811L10.6761 13.3798L17.6796 5.84493C17.8548 5.65646 17.9911 5.43532 18.0808 5.19415C18.1706 4.95299 18.2119 4.69651 18.2025 4.43936C18.1931 4.18222 18.1331 3.92944 18.0261 3.69547C17.919 3.46149 17.7668 3.2509 17.5784 3.07572C17.3899 2.90054 17.1688 2.7642 16.9276 2.67447C16.6864 2.58475 16.4299 2.54341 16.1728 2.55281C15.9157 2.56221 15.6629 2.62217 15.4289 2.72926C15.1949 2.83635 14.9843 2.98847 14.8092 3.17695L7.80569 10.7118L7.90692 13.4811Z",
    stroke: "#C4C8CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1422 3.89453L17.0126 6.56252L14.1422 3.89453Z",
    fill: "#C4C8CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1422 3.89453L17.0126 6.56252",
    stroke: "#C4C8CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32361 15.0415C3.85175 15.6957 0.93801 17.7173 2.037 19.4443C3.25463 21.3577 11.3072 18.3271 12.6344 17.9724C14.355 17.5126 16.0687 17.7762 15.7743 19.4443C15.48 21.1124 16.0631 22.3195 18.0256 21.8289C19.5956 21.4364 21.58 19.9185 22.4467 19.4443",
    stroke: "#C4C8CF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/Signature.f56cf238eb3513e859aab3e2ad3a753b.svg";
export { ForwardRef as ReactComponent };